<template>
    <inertia-head>
        <title>Kontakta oss</title>
        <meta property="og:image" content="/assets/frontend/hero.jpg" />
        <link rel="canonical" :href="canonical">
    </inertia-head>

    <main role="main" class="main contact page-content-padding">
        <breadcrumb>
            <breadcrumb-item>
                <inertia-link href="/">Hem</inertia-link>
            </breadcrumb-item>
            <breadcrumb-item :last="true">
                Kontakta oss
            </breadcrumb-item>
        </breadcrumb>

        <div class="container content pb-5">
            <h1 class="page-heading text-red">{{ $t('contact_us') }}</h1>
            <form @submit.prevent="sendMessage" @keydown="form.errors.clear($event.target.name)" class="contact-form mt-4">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="row no-gutters">
                            <div class="col-12 col-md-6 pr-md-2" id="first-name">
                                <input type="text" name="first_name" class="form-control mt-2" :placeholder="'* '+ $t('first_name')" v-model="form.first_name" :class="{ 'is-invalid': form.errors.has('first_name') }">
                                <div v-if="form.errors.has('first_name')" class="invalid-feedback d-block text-left">
                                    {{ form.getError('first_name') }}
                                </div>
                            </div>
                            <div class="col-12 col-md-6 pl-md-2" id="last-name">
                                <input type="text" name="last_name" class="form-control mt-2" :placeholder="'* '+ $t('last_name')" v-model="form.last_name" :class="{ 'is-invalid': form.errors.has('last_name') }">
                                <div v-if="form.errors.has('last_name')" class="invalid-feedback d-block text-left">
                                    {{ form.getError('last_name') }}
                                </div>
                            </div>
                        </div>

                        <input type="text" name="phone" class="form-control mt-2" :placeholder="$t('telephone')" v-model="form.phone" :class="{ 'is-invalid': form.errors.has('phone') }">
                        <div v-if="form.errors.has('phone')" class="invalid-feedback d-block text-left">
                            {{ form.getError('phone') }}
                        </div>

                        <input type="text" name="email" class="form-control mt-2" :placeholder="'* '+ $t('email')" v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }">
                        <div v-if="form.errors.has('email')" class="invalid-feedback d-block text-left">
                            {{ form.getError('email') }}
                        </div>

                         <input type="text" name="company" class="form-control mt-2" v-model="form.company" :placeholder="' '+ $t('Ev företag')">
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <select class="form-control"  name="errand" v-model="form.errand" :class="{ 'is-invalid': form.errors.has('errand') }">
                            <option :value="null">* Ditt ärende</option>
                            <optgroup label="FÖRETAG">
                                <option value="FÖRETAG - Annonsmaterial">Annonsmaterial</option>
                                <option value="FÖRETAG - Frågor om mitt avtal">Frågor om mitt avtal</option>
                                <option value="FÖRETAG - Bli kund">Bli kund</option>
                                <option value="FÖRETAG - Ekonomi">Ekonomi</option>
                                <option value="FÖRETAG - Övrigt">Övrigt</option>
                            </optgroup>
                            <optgroup label="MEDLEM PRIVATPERSON">
                                <option value="MEDLEM PRIVATPERSON - Frågor om mitt medlemskap">Frågor om mitt medlemskap</option>
                                <option value="MEDLEM PRIVATPERSON - Synpunkter">Synpunkter</option>
                                <option value="MEDLEM PRIVATPERSON - Övrigt">Övrigt</option>
                            </optgroup>
                        </select>
                        <div v-if="form.errors.has('errand')" class="invalid-feedback d-block text-left">
                            {{ form.getError('errand') }}
                        </div>

                        <textarea class="form-control mt-2" rows="5" :placeholder="'* '+ $t('message')" v-model="form.message" :class="{ 'is-invalid': form.errors.has('message') }"></textarea>
                        <div v-if="form.errors.has('message')" class="invalid-feedback d-block text-left">
                            {{ form.getError('message') }}
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-danger mt-2" v-if="form.processing">Laddar...</button>
                <button type="submit" class="btn btn-danger mt-2" v-if="!form.processing">{{ $t('send') }}</button>
            </form>
           <!-- <span class="d-block pt-3" style="font-weight: 800; text-decoration: underline;">Julstängt 23/12 - 2/1</span> -->
            <span class="d-block pt-2">
               Kontakta oss via formuläret eller via telefon <a href="tel:0334308090">033-430 80 90</a>
            </span>
            <span class="d-block mt-2">Telefontider måndag-fredag kl 09-15 (lunchstängt 12-13)</span>
	    <span class="d-block mt-2" style="font-style: italic;">Obs! Växeln stängd v 28. Öppet måndag-onsdag kl 09-12, v 29-32</span>
        </div>
    </main>
</template>

<script>
    import Form from 'form-backend-validation';

    export default {
        props: ['canonical'],

        data(){
            return{
                form: new Form({
                    first_name: null,
                    last_name: null,
                    email: null,
                    message: null,
                    errand: null,
                    phone: null,
                }),
            }
        },
        mounted() {
            window.scrollTo(0, 0);
        },
        metaInfo() {
            return {
                title: 'Kontakta oss - Familjekortet',
            };
        },
        methods: {
            sendMessage(){
                if (this.form.processing) {
                    return;
                }

                this.form.processing = true;

                setTimeout(() => {
                    this.form.post(`/api/site/message`).then(response => {
                        this.$moshaToast('Meddelandet skickades!', {
                            type: 'success',
                            timeout: 2000,
                        });
                    });
                }, 300);
            }
        }
    }
</script>

